// @ts-nocheck
// plugins/signal-pixel.client.ts
import { afterInteraction } from '../common/afterInteraction';

export default defineNuxtPlugin(() => {
  const ID = '7383305285777572639';
  const SDK_SRC = 'https://dltz00c894r7u.cloudfront.net/sdk/7383305285777572639/events.js';
  const HOST = 'https://fmkymdpq46.us-east-1.awsapprunner.com/';
  const SCRIPT_ID = 'signals-gateway-sdk';

  const w = window as any;
  if (!w.cbq) {
    const n = function (...args: any[]) {
      if ((n as any).callMethod) {
        (n as any).callMethod.apply(n, args);
      } else {
        (n as any).queue.push(args);
      }
    }

    ;(n as any).push = n
    ;(n as any).loaded = true
    ;(n as any).version = '2.0'
    ;(n as any).queue = [];

    w.cbq = n;
    w._cbq = n;
  }

  afterInteraction().then(() => {
    if (!document.getElementById(SCRIPT_ID)) {
      const t = document.createElement('script');
      t.async = true;
      t.src = SDK_SRC;
      t.id = SCRIPT_ID;
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
  });

  type CbqMethod = 'track' | 'setHost' | string;
  const cbqTrack = (method: CbqMethod, ...args: any[]) => {
    w.cbq(method, ...args);
  };

  const cbqInit = (params?: any) => {
    w.cbq('init', ID, params);
  };

  cbqTrack('setHost', HOST);

  return {
    provide: {
      cbqTrack,
      cbqInit,
    },
  };
});
